module.exports = __webpack_public_path__ + "img/20200905_130158.0782c263.jpg";